import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';
import { getSupplierSummary } from '../../common/endpoints';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const fetchSupplierSummary = createApi(
  getSupplierSummary,
  'GET'
);

const supplierSummarySlice = createSlice({
  name: 'supplierSummary',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSupplierSummary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSupplierSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchSupplierSummary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default supplierSummarySlice.reducer;
